<template>
  <div></div>
</template>

<script>
  import { mapState } from 'vuex';
  import { VOTE_CONTENT_TYPES } from '../../config/session';
  import * as roles from '../../utils/user-roles';

  export default {
    name: 'SocketRoom',
    computed: {
      ...mapState('auth', ['token', 'userRoles']),
    },
    sockets: {
      vote(data) {
        if (
          data.type === VOTE_CONTENT_TYPES.VOTING
          && this.userRoles.includes(roles.ROLE_VOTE_VIEWER)
          && this.$route.name !== 'vote-active'
        ) {
          this.$router.push({ path: '/vote/active' });
        }
      },
    },
    created() {
      if (!this.userRoles.includes(roles.ROLE_VOTE_VIEWER)) {
        this.$socket.io.opts.query.token = this.token;
        this.$socket.connect();
      }
    },
  };
</script>
